import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from '../../components/navigation/Sidebar';
import NotificationCenter from '../../components/navigation/NotificationCenter';
import QuickActionMenu from '../../components/navigation/QuickActionMenu';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import MessagingPanel from '../expert-dashboard/components/MessagingPanel';
import { getUserContracts } from '../../services/contractService';

const ClientMessages = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialUserId = searchParams.get('userId') || undefined;
  const [contracts, setContracts] = useState([]);

  useEffect(() => {
    if (!user?.id) return;
    getUserContracts(user.id, 'client').then((result) => {
      if (result?.success) setContracts(result.contracts || []);
    });
  }, [user?.id]);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar userRole="client" />
      <QuickActionMenu userRole="client" />
      <div className="lg:ml-60 min-h-screen">
        <header className="sticky top-0 z-40 bg-card border-b border-border px-4 md:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                onClick={() => {
                  const isCollapsed = document.body.classList.toggle('sidebar-collapsed');
                  localStorage.setItem('sidebarCollapsed', isCollapsed.toString());
                }}
                className="p-2 hover:bg-muted rounded-lg transition-colors"
                aria-label="Toggle sidebar"
              >
                <Icon name="PanelLeft" size={24} />
              </button>
              <div>
                <h1 className="text-2xl md:text-3xl font-semibold text-foreground">Messages</h1>
                <p className="text-sm text-muted-foreground mt-1">
                  Communicate with your assigned experts.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <NotificationCenter userRole="client" />
              <Button
                variant="outline"
                iconName="LogOut"
                iconPosition="left"
                onClick={async () => { await signOut(); navigate('/login'); }}
              >
                Logout
              </Button>
            </div>
          </div>
        </header>

        <main className="px-4 md:px-6 lg:px-8 py-6 md:py-8">
          <MessagingPanel
            contracts={contracts}
            userId={user?.id}
            userType="client"
            initialUserId={initialUserId}
          />
        </main>
      </div>
    </div>
  );
};

export default ClientMessages;
